import { render, staticRenderFns } from "./personEdit.vue?vue&type=template&id=64d7d197&scoped=true&"
import script from "./personEdit.vue?vue&type=script&lang=js&"
export * from "./personEdit.vue?vue&type=script&lang=js&"
import style0 from "./personEdit.vue?vue&type=style&index=0&id=64d7d197&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d7d197",
  null
  
)

export default component.exports